<template>
  <base-section id="article" space="72">
    <v-container class="py-0">
      <v-row justify="center">
        <v-col cols="12" md="10">
          <news-card class="mb-4" prominent v-bind="currentArticle" />

          <!-- <news-share /> -->

          <news-author v-bind="author" />

          <back-to-blog-overview></back-to-blog-overview>

          <h1>Comments</h1>

          <iframe
            v-if="slug"
            v-bind:src="
              `https://talk.hoarder.software/embed/comments?embed_url=https%3A%2F%2Fmedia.hoarder.software%2Fblog%2F${slug}%2F`
            "
            id="discourse-embed-frame"
            width="100%"
            v-bind:height="`${iframeHeight}px`"
            frameborder="0"
            scrolling="no"
            referrerpolicy="no-referrer-when-downgrade"
          />

          <back-to-blog-overview
            v-if="iframeHeight > 900"
          ></back-to-blog-overview>
        </v-col>

        <!-- <v-col
          class="hidden-sm-and-down"
          cols="3"
        >
          <news-search />

          <news-categories />

          <news-recent-articles />

          <news-archives />

          <news-tags />
        </v-col> -->
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
import { marked } from "marked";
import BackToBlogOverview from "./BackToBlogOverview.vue";

const articles = require("../../blog-articles.json");
const authors = require("../../blog-authors.json");

export default {
  name: "SectionArticle",

  components: {
    // NewsArchives: () => import('@/components/news/Archives'),
    // NewsRecentArticles: () => import('@/components/news/RecentArticles'),
    NewsAuthor: () => import("@/components/news/Author"),
    NewsCard: () => import("@/components/news/Card"),
    BackToBlogOverview
    // NewsCategories: () => import('@/components/news/Categories'),
    // NewsCommentReply: () => import('@/components/news/CommentReply'),
    // NewsComments: () => import('@/components/news/Comments'),
    // NewsSearch: () => import('@/components/news/Search'),
    // NewsShare: () => import('@/components/news/Share'),
    // NewsTags: () => import('@/components/news/Tags'),
  },

  data: () => ({
    slug: null,
    currentArticle: null,
    iframeHeight: 0
  }),

  computed: {
    articles() {
      return articles;
    },

    author() {
      if (!authors) {
        return undefined;
      }

      if (!this.currentArticle) {
        return undefined;
      }

      return Object.assign(authors[this.currentArticle["author-id"]], {
        src: require(`@/assets/avatars/${this.currentArticle["author-id"]}.png`)
      });
    }
  },

  methods: {
    // iframe communcation
    receiveMessage(event) {
      console.log("[receiveMessage] event:", event);

      if (!event) {
        console.log("[receiveMessage]   no event data, abort");
        return;
      }
      if (!(event.origin || "").includes("talk.hoarder.software")) {
        console.log(
          "[receiveMessage]   event.origin does not contain talk.hoarder.software, abort"
        );
        return;
      }

      if (event.data) {
        if (event.data.type === "discourse-resize" && event.data.height) {
          console.log(
            `[receiveMessage]   got resize event, setting iframeHeight to ${event.data.height}px`
          );
          this.iframeHeight = +event.data.height;
        }

        if (event.data.type === "discourse-scroll" && event.data.top) {
          console.log(`[receiveMessage]   discourse-scroll event`);
          // find iframe offset
          const destY =
            this.findPosY(this.$refs["discourse-embed-frame"]) + event.data.top;
          console.log(`[receiveMessage]   scrolling to`, destY);
          window.scrollTo(0, destY);
        }
      }
    },

    // Thanks to http://amendsoft-javascript.blogspot.ca/2010/04/find-x-and-y-coordinate-of-html-control.html
    findPosY(obj) {
      var top = 0;
      if (obj.offsetParent) {
        while (1) {
          top += obj.offsetTop;
          if (!obj.offsetParent) break;
          obj = obj.offsetParent;
        }
      } else if (obj.y) {
        top += obj.y;
      }
      return top;
    }
  },

  async created() {
    this.slug = this.$router.currentRoute.path.split("/")[2];

    const renderer = new marked.Renderer();
    const baseURL =
      process.env.NODE_ENV === "development"
        ? ""
        : "https://themk2k.github.io/software.hoarder.media.dist";

    // open links in new tab
    const linkRenderer = renderer.link;
    renderer.link = (href, title, text) => {
      const localLink = href.startsWith(
        `${location.protocol}//${location.hostname}`
      );
      const html = linkRenderer.call(renderer, href, title, text);
      return localLink
        ? html
        : html.replace(
            /^<a /,
            `<a target="_blank" rel="noreferrer noopener nofollow" `
          );
    };

    // insert a blank line after (un)ordered lists
    const listRenderer = renderer.list;
    renderer.list = (body, ordered, start) => {
      const html = listRenderer.call(renderer, body, ordered, start);
      return html.replace(/<\/ul>/, `</ul><p />`).replace(/<\/ol>/, `</ol><p />`)
    }

    // inject baseURL in image sources
    const imageRenderer = renderer.image;
    renderer.image = (href, title, text) => {
      const html = imageRenderer.call(renderer, href, title, text);
      return html.replace(/src="/, `src="${baseURL ? `${baseURL}/blog/` : ""}`);
    };

    // remove level 1 header (this is already part of blog-articles.json)
    const headingRenderer = renderer.heading;
    renderer.heading = (text, level, raw, slugger) => {
      if (level !== 1) {
        return headingRenderer.call(renderer, text, level, raw, slugger);
      }

      return "";
    };

    // load /blog/${this.slug}.md, convert it to html and provide it as currentArticle.html
    const response = await fetch(`${baseURL}/blog/${this.slug}.md`);
    const md = await response.text();
    const html = marked(md, {
      renderer
      // highlight: function(markdown) {
      //   return hljs.highlightAuto(markdown).value;
      // }
    });

    this.currentArticle = Object.assign(
      articles.find(article => article.slug === this.slug),
      { html }
    );
  },

  // iframe communication
  mounted() {
    window.addEventListener("message", this.receiveMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  }
};
</script>
